/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Promos_Recorded_EditInputs */



/**
* | output |
* | --- |
* | "{count} promo(s) recorded · Edit" |
*
* @param {Promos_Recorded_EditInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promos_recorded_edit = /** @type {((inputs: Promos_Recorded_EditInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promos_Recorded_EditInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} promo(s) enregistrée(s) · Modifier`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} promo(s) registrada(s) · Editar`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`${i?.count} promo(s) registrada(s) · Editar`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} promo registrata/e · Modifica`)
	return /** @type {LocalizedString} */ (`${i?.count} promo(s) recorded · Edit`)
});